import React, { Fragment, useState, useEffect } from 'react'
import moment from 'moment'
import { Form, Button, Row, Col, Table } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import Cookies from 'js-cookie'
import config from '../../config'
import { AFFILIATE_TRANSACTION_STATUS_TEXT_COLOR } from './constants'
import { TypeText } from './index.styles'
import { getRounds } from '../../services/config-services'

export default function AffiliateTransaction() {
  const [userNo, setUserNo] = useState('')
  const [affiliateData, setAffiliateData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [rounds, setRounds] = useState([])
  const [roundDate, setRoundDate] = useState('')
  const dispatch = useDispatch()
  const [pagination, setPagination] = useState({
    page: 1,
    hasNext: false,
  })

  const onClickClear = () => {
    setUserNo('')
    setPagination({
      page: 1,
      hasNext: false,
    })
    setCurrentPage(1)
    setAffiliateData([])
  }

  const onSearchUser = async () => {
    try {
      dispatch({ type: 'loading_show' })
      if(userNo) {
        const params = new URLSearchParams({
          userNo: userNo,
          roundDate: roundDate,
          page: currentPage,
          limit: 10,
        })
        const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/affiliates/transactions?${params.toString()}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        }).then((res) => res.json())
  
        if (response.status.code !== 0) throw new Error(response.status.description)
  
        setAffiliateData(response.data)
        setPagination((pagination) => ({
          ...pagination,
          hasNext: response.pagination.hasNext,
        }))
      }
    } catch (error) {
      console.error(error)
      setAffiliateData([])
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const onEnterSearch = (e) => {
    e.preventDefault()
    onSearchUser()
    setPagination({
      page: 1,
      hasNext: false,
    })
    setCurrentPage(1)
  }

  useEffect(() => {
    onSearchUser()
  },[currentPage])

  useEffect(() => {
    setPagination({
      page: 1,
      hasNext: false,
    })
    setCurrentPage(1)
    onSearchUser()
  },[roundDate])

  useEffect(() => {
    const fetchRounds = async () => {
      try {
        const response = await getRounds()
        if(response?.length > 0){
          const rounds = response[0]
          setRoundDate(rounds.value)
        }
        setRounds(response)
      } catch (error) {
        setRounds([])
      }
    }
    fetchRounds()
  }, [])

  const displayTableAffiliat = () => {
    return (
      <Table responsive striped bordered className="verticle-middle">
        <thead>
          <tr>
            <th>หมายเลขคำสั่งซื้อ</th>
            <th>ประเภท</th>
            <th>ได้รับ / ถอน ค่าคอมมิชชั่น</th>
            <th>วันที่ / เวลา ที่ทำรายการ</th>
          </tr>
        </thead>
        <tbody>
          {affiliateData.length > 0 ?
            affiliateData.map((value, i) => {
              return (
                <tr key={i}>
                  <td>{value.orderNo}</td>
                  <td>
                    <TypeText color={AFFILIATE_TRANSACTION_STATUS_TEXT_COLOR[value.type]}>{value.type}</TypeText>
                    </td>
                  <td>
                  <TypeText color={AFFILIATE_TRANSACTION_STATUS_TEXT_COLOR[value.type]}>{value.amount}</TypeText>
                  </td>
                  <td>{moment(value.createdAt).format('DD/MM/YYYY HH:mm')}</td>
                </tr>
              )
            }) : 
            <tr>
              <td colSpan="4" style={{textAlign: 'center'}}>ไม่พบข้อมูล</td>
            </tr>
          }
        </tbody>
      </Table>
    )
  }

  const handleClickNextPage = () => {
    setCurrentPage((current) => current + 1)
  }

  const handleClickPrevPage = () => {
    setCurrentPage((current) => current - 1)
  }

  return (
    <Fragment>
      <Row style={{ padding: '8px 0'}} >
        <Col sm={12}>
          <Form>
            <Form.Group>
              <Row>
                <Col sm={12}>
                  <Row>
                    <Col md={8} lg={8}>
                      <input
                        className="form-control"
                        style={{ color: '#5d5d5d' }}
                        type="text"
                        placeholder="รหัสสมาชิก"
                        onChange={(e) => setUserNo(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            onEnterSearch(e)
                          }
                        }}
                        value={userNo}
                      />
                    </Col>
                    <Col md={4} lg={4}>
                      <div
                        style={{ display: 'flex' }}
                      >
                        <span style={{ width: '15%', alignContent: 'center'}}>งวดที่ :</span>
                        <select
                          className="form-control"
                          style={{ width: '85%'}}
                          value={roundDate}
                          onChange={(e) => setRoundDate(e.target.value)}
                        >
                          {rounds.map((item, i) => {
                            return (
                              <option key={i} value={item.value}>
                                {item.value}
                              </option>
                            )
                          })}
                        </select>
                      </div>
                    </Col>
                    <Col sm={6} style={{ margin: '8px 0'}}>
                      <Button variant="danger light" className="w-50" onClick={() => onClickClear()}>
                        ล้างตัวกรอง
                      </Button>
                      <Button variant="primary light" className="w-50" onClick={() => onSearchUser()}>
                        ค้นหา
                      </Button>
                    </Col>
                    <Row>
                    </Row>
                  </Row>
                </Col>
              </Row>
            </Form.Group>
          </Form>
          {displayTableAffiliat()}
          <div className="d-flex justify-content-center">
            <div>
              {currentPage !== 1 && (
                <button className="btn btn-primary mr-2" onClick={handleClickPrevPage}>
                  ก่อนหน้า
                </button>
              )}
              <button className="btn btn-primary" disabled>
                {currentPage}
              </button>
              {pagination?.hasNext && (
                <button className="btn btn-primary ml-2" onClick={handleClickNextPage}>
                  ถัดไป
                </button>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
}
